// tslint:disable-next-line:no-submodule-imports
import { all } from "redux-saga/effects";
import logActionsWatcher from "./logActions";
import pocketbookSaga from "./pocketbook";
import awsMarketplaceSaga from "./awsmarketplace";
import reactionAnalyzerPersistenceSaga from "./reactionAnalyzerPersistence";
import rsaaErrorNotificationsSaga from "./rsaaErrorNotifications";

export default function* rootSaga() {
    yield all([
        pocketbookSaga(),
        logActionsWatcher(),
        awsMarketplaceSaga(),
        reactionAnalyzerPersistenceSaga(),
        rsaaErrorNotificationsSaga(),
    ]);
}
